import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/global';
import isEqual from 'deep-equal';
import { fetchingState } from '../../constants';

const initialStats = {
  preference: {},
  form: {},
  selectedProperty: '',
  selectedYear: '',
  selectedCategory: null,
  isMenuVisible: false,
  property: {
    isChildProperty: false,
    parentPropID: 0,
    parentPropYr: 0,
  },
  cacheRemovingProgress: fetchingState.LOADED,
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    // User actions
    // ////////////

    case actions.PREFERENCE_FETCH_START:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case actions.PREFERENCE_FETCH_SUCCESS:
      const newState = state.setIn(
        ['preference', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case actions.PREFERENCE_FETCH_ERROR:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case actions.SELECT_PROPERTY:
      return action.data === state.get('selectedProperty')
        ? state
        : state.set('selectedProperty', action.data);
    case actions.SELECT_YEAR:
      return action.data === state.get('selectedYear')
        ? state
        : state.set('selectedYear', action.data);
    case actions.SELECT_CATEGORY:
      return isEqual(
        action.data,
        state.get('selectedCategory')
          ? state.get('selectedCategory').toJS()
          : state.get('selectedCategory'),
      )
        ? state
        : state.set('selectedCategory', fromJS(action.data));

    case actions.CACHE_REFRESH_START:
      return state.set('cacheRemovingProgress', fetchingState.FETCHING);
    case actions.CACHE_REFRESH_SUCCESS:
      return state.set('cacheRemovingProgress', fetchingState.LOADED);
    case actions.CACHE_REFRESH_ERROR:
      return state.set('cacheRemovingProgress', fetchingState.ERROR);

    case actions.CHECK_IS_CHILD_PROPERTY_SUCCESS: {
      return state.set('property', fromJS(R.path(['data', 'results'])(action)));
    }

    case actions.TOGGLE_MENU:
      return state.set('isMenuVisible', !state.get('isMenuVisible'));
    // Global actions
    // //////////////
    default:
      return state;
  }
};
